const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_PURCHASE_PLANNING",
    modulePath: "hml-new-netsuite.purchase",
    moduleName: "purchase",
    language: "pt",
    port: 8084,
    theme: "venturus.js",
    env: "hml-new-netsuite",
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
